import { render, staticRenderFns } from "./TenderKeywordsDrawer.vue?vue&type=template&id=d8027426"
import script from "./TenderKeywordsDrawer.vue?vue&type=script&lang=js"
export * from "./TenderKeywordsDrawer.vue?vue&type=script&lang=js"
import style0 from "./TenderKeywordsDrawer.vue?vue&type=style&index=0&id=d8027426&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports